import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { CommendaServicesResponse, UseCommendaServicesParams } from './types';

export function useCommendaServices(
  params?: UseCommendaServicesParams,
  token?: string
) {
  const searchParams = new URLSearchParams();
  if (params?.query) searchParams.set('query', params.query);
  if (params?.category) searchParams.set('category', params.category);
  if (params?.subcategory) searchParams.set('subcategory', params.subcategory);
  if (params?.country) searchParams.set('country', params.country);
  if (params?.jurisdiction)
    searchParams.set('jurisdiction', params.jurisdiction);
  searchParams.set('limit', String(params?.limit ?? 25));

  const url =
    params?.enabled === false
      ? null
      : `commenda-services?${searchParams.toString()}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: CommendaServicesResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(url, SWRFetcher({ method: 'GET' }, token));

  return {
    data,
    error,
    mutate,
    isLoading: url !== null && !data && !error,
  };
}
